module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Vorspiel")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Eine russische Schenke. Eine breite Tür im\nHintergrunde der Bühne; draußen schneebedeckte\nWinterlandschaft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter Saburoff, Michael.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("seine\nHände am Ofen wärmend")]), _vm._v("): Ist Vera noch nicht zurück,\nMichael?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Nein, noch nicht, Vater\nPeter. Bis zur Post sind's drei gute Meilen, – und dann hat sie\nauch noch die Kühe zu melken. Die braune ist ein Luder – die macht\neinem Mädel mehr als genug zu schaffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Warum hast du sie nicht\nbegleitet, junger Faulpelz? So wird sie dir nie gut sein, wenn du\nihr nicht immer auf den Fersen bist. Die Weiber wollen geplagt\nwerden.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Sie sagt, ich setze ihr\nohnehin schon mehr als genug zu, Vater Peter; und trotzdem fürchte\nich, wird sie mich nie liebhaben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Aber, aber, Bürschchen,\nwarum denn nicht? Du bist jung, und wärst so übel nicht, wenn du\nvon Gott oder deiner Mutter ein anderes Gesicht bekommen hättest.\nBist du nicht Förster beim Fürsten Maraloffski? Und gehört dir\nnicht ein schöner Hof und die beste Kuh im Dorf? Was braucht ein\nMädel mehr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Schon gut, Vater, aber\nVera –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Vera, mein Junge, denkt mir\nzu viel. Ich selbst geb' nicht viel aufs Denken. Ich hab's ohne das\nim Leben weit genug gebracht – warum sollten's nicht auch meine\nKinder? Nimm zum Beispiel Dimitri! Er hätte hierbleiben und die\nWirtschaft übernehmen können. Bei den Zeiten wäre mancher Bursch\nvor Freude in die Höh gesprungen, hätte man ihm den Vorschlag\ngemacht; "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page6",
      "title": "divisi/KaFa"
    }
  }), _vm._v(" aber\ner, der tolle Windbeutel, muß nach Moskau und die Rechte studieren!\nWas braucht er davon zu verstehen? Ich sag', wenn einer seine\nPflicht tut, kann ihm keiner etwas anhaben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ja, Vater Peter, es heißt\naber doch, ein guter Advokat kann mit dem Gesetze machen, was er\nwill, und keiner kann's ihm legen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Zu was anderem taugen sie\nauch nicht. Und nun ist Dimitri dort und hat uns seit vier Monaten\nkeine Zeile geschrieben. Ein feiner Sohn – was?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Laß es gut sein, Vater\nPeter, Dimitris Briefe werden halt verloren gegangen sein –\nvielleicht kann der neue Briefträger nicht lesen; dumm genug sieht\ner aus. Dimitri war doch der beste Bursch im Dorf. Erinnerst du\ndich noch, wie er im Winter den Bären bei der Scheune geschossen\nhat?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ja, 's war ein guter Schuß,\nbesser hab' ich auch nie getroffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Und erst beim Tanz: er\nhat's länger ausgehalten als drei Fiedler – nächste Weihnachten\nwerden's zwei Jahre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ja, ja, er war ein lustiger\nBursch. Das Mädel ist dagegen zu ernst – manchmal geht sie tagelang\nherum so feierlich wie ein Pope.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Vera denkt immer nur an\ndie anderen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Das ist ihr Fehler, Junge.\nLaß Gott und unser Väterchen sich um die Welt kümmern. Ich hab' das\nDach meines Nachbarn nicht zu flicken. Letzten Winter ist der alte\nMichael auf seinem Schlitten im Schneesturm erfroren, und sein Weib\nund seine Kinder sind verhungert, wie dann hernach die Teuerung\ngekommen ist. Was geht's mich an? Ich hab' die Welt nicht gemacht.\nLaß Gott und den Zaren sich darum kümmern. Dann kam der "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page7",
      "title": "divisi/a41b"
    }
  }), _vm._v(" Brand und die\nschwarze Pest dazu, und die Popen konnten das Volk nicht schnell\ngenug begraben, und die Menschen lagen tot auf den Straßen herum –\nMänner und Weiber. Was geht's mich an? Ich habe die Welt nicht\ngemacht. Laß Gott und den Zaren sich darum kümmern … Oder im\nvorletzten Herbst – da trat der Fluß plötzlich aus und riß die\nSchule weg, und alle Mädchen und Buben ertranken drin. Ich hab' die\nWelt nicht gemacht. Laß Gott und den Zaren sich drum\nkümmern …")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Ja, Vater Peter, aber\n–")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Nein, nein, mein Junge –\nkein Mensch könnt' leben, müßt er des Nachbarn Kreuz auf seinen\nSchultern tragen. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Vera, in ländliche Tracht\ngekleidet, tritt ein.")]), _vm._v(") Na, Mädel, du warst lang genug weg –\nwo ist der Brief?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Heut ist keiner gekommen,\nVater.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ich hab's gewußt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Aber morgen wird einer\nkommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Verflucht sei er, der\nungeratene Sohn!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Sprich nicht so, Vater. Er\nmuß krank sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Wahrscheinlich krank von\nseinen Ausschweifungen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wie kannst du so etwas von\nihm sagen, Vater! Du weißt ja selbst, daß es nicht wahr ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Wo kommt sein Geld dann hin?\nHör' zu, Michael. Ich hab' Dimitri das halbe Erbteil seiner Mutter\nmitgegeben, damit er das Advokatenpack in Moskau bezahlt. Er hat\nnur dreimal geschrieben, jedesmal wieder um Geld. Er hat's\nbekommen, nicht weil ich, sondern weil sie es wollte ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("auf Vera weisend")]), _vm._v("), und nun haben wir seit fünf,\nnein, seit fast sechs Monaten nichts mehr von ihm gehört.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Vater, er wird\nwiederkommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ja, der verlorene Sohn kommt\nimmer wieder; er soll meine Schwelle nie wieder betreten! "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page8",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("setzt\nsich, in Gedanken versunken, nieder")]), _vm._v("): Es muß ihm etwas Böses\npassiert sein. Er muß tot sein! Michael, ich hab' solche Sorgen um\nDimitri!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Wirst du nie einen anderen\nlieben als Dimitri?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("lächelnd")]), _vm._v("): Weiß ich's denn? Es gibt auf Erden so\nviel mehr zu tun, als sich zu verlieben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(": Nichts sonst, was der Mühe\nwert ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Was ist das für ein Lärm,\nVera? ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Man hört von außen klirrendes\nGeräusch.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("aufspringend und zur Tür eilend")]), _vm._v("): Ich weiß nicht,\nVater. Es klingt nicht wie Kuhglocken, sonst würde ich meinen,\nNikolas sei vom Markt zurück. Vater, es sind Soldaten! – Sie kommen\nvom Hügel – einer von ihnen zu Pferd. Wie hübsch es aussieht! Aber\nMänner in Ketten sind dabei! Das müssen Räuber sein! Laß sie nicht\nherein, Vater, ich kann das nicht sehen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Männer in Ketten! Hurra, wir\nhaben Glück, mein Kind! Ich hab' gehört, hier führt die neue Straße\nnach Sibirien vorbei, auf der man die Gefangenen in die Bergwerke\nschafft. Ich wollt' es aber nicht glauben. Jetzt ist mein Glück\ngemacht! Tummle dich, Vera, tummle dich! Ich werd' doch noch als\nreicher Mann sterben. An guten Gästen wird's jetzt nicht fehlen.\nAuch ein ehrlicher Mann sollt' einmal das Glück haben, an Lumpen\nsein Geld zu verdienen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Sind diese Männer denn\nLumpen? Was haben sie getan?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ich denke mir, es sind\nNihilisten, vor denen uns der Pope warnt. Steh nicht so müßig\nherum, Mädel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Dann sind es sicher lauter\nschlechte Menschen. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Vor der Türe Lärm von\nSoldaten. Kommando: »Halt!« Ein russischer Offizier mit einer Schar\nSoldaten und acht zerlumpt gekleideten Männern in Ketten tritt ein.\nEiner von ihnen schlägt rasch den Mantelkragen "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page9",
      "title": "divisi/a41b"
    }
  }), _vm._v(" auf und verbirgt sein Gesicht;\neinige Soldaten wachen an der Türe, andere setzen sich nieder; die\nGefangenen bleiben stehen.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Wirt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Jawohl, Herr Oberst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("auf\ndie Nihilisten weisend")]), _vm._v("): Gib den Leuten Wasser und Brot.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("für\nsich")]), _vm._v("): Bei der Bestellung werd' ich nicht viel\nverdienen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Was ist für mich da?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Gutes gepökeltes Wild, Eure\nExzellenz, – und Kornbranntwein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Sonst nichts?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": O ja, Exzellenz, noch mehr\nBranntwein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Was für Tölpel die Bauern\nsind! Hast du ein besseres Zimmer als das hier?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ja, Herr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Führ' mich hin. Sergeant,\npostier' die Wache draußen und gib acht, daß die Schufte sich mit\nkeinem unterhalten. Briefschreiben ist verboten, ihr Hunde, oder\nich laß euch peitschen. Und jetzt zum Wildbret. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Zu Peter, der sich vor ihm verbeugt")]), _vm._v("): Aus dem Weg,\ndu Dummkopf! ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Vera erblickend.")]), _vm._v(") Wer ist\ndas Mädchen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Meine Tochter, Hoheit.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Kann sie lesen und\nschreiben?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Gewiß, Herr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Dann ist sie verdächtig.\nKein Bauer sollte so etwas können. Bestellt euer Feld, bringt eure\nErnte ein, zahlt eure Steuern und gehorcht euren Herren – mehr habt\nihr nicht zu tun.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wer sind denn unsere\nHerren?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Junge Person, die Männer da\ngehen auf Lebenszeit in die Bergwerke, weil sie dasselbe tolle Zeug\ngefragt haben. "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page10",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Dann hat man sie ungerecht\nverurteilt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Vera, halt' deinen Mund! Sie\nist ein albernes Mädel, Herr, das zu viel schwätzt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Die Frauenzimmer schwätzen\nalle zu viel. Vorwärts – wo ist das Wildbret? Herr Graf, ich\nerwarte Sie. Was können Sie nur an einem Mädel mit roten Händen\nfinden? ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er geht mit Peter und seinem\nAdjutanten in ein Nebenzimmer.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu einem\nder Nihilisten")]), _vm._v("): Wollt Ihr euch nicht setzen? Ihr müßt müde\nsein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wachtmeister")]), _vm._v(": Halt, junge Person,\nnicht mit meinen Gefangenen sprechen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ich will mit ihnen sprechen.\nWieviel verlangt Ihr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wachtmeister")]), _vm._v(": Wieviel gibst du?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Würdet Ihr erlauben, daß sich\ndie Männer setzen, wenn ich Euch das hier gebe? ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Nestelt ihre Halskette auf.")]), _vm._v(") Es ist alles, was ich\nhab'. Es hat meiner Mutter gehört.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wachtmeister")]), _vm._v(": Gut, es sieht ganz\nhübsch aus und ist auch schwer. Was willst du von den Männern?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Sie sind hungrig und müde.\nLaßt mich zu ihnen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Einer von den Soldaten")]), _vm._v(": Laß die\nDirne nur, wenn sie uns dafür zahlt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wachtmeister")]), _vm._v(": Gut, hab' deinen\nWillen. Wenn dich aber der Oberst sieht, kannst du gleich\nmitkommen, mein Schätzchen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu den\nNihilisten gehend")]), _vm._v("): Setzt euch. Ihr müßt müde sein. (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Reicht ihnen Speise.")]), _vm._v(") Was seid ihr?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Gefangener")]), _vm._v(": Nihilisten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wer hat euch in Ketten\ngelegt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Gefangene")]), _vm._v(": Unser Vater, der\nZar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Warum? "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page11",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Gefangene")]), _vm._v(": Weil uns die\nFreiheit zu teuer war!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("zu dem\nGefangenen, der sein Gesicht verbirgt")]), _vm._v("): Was hast du tun\nwollen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Dreißig Millionen\nMenschen, die ein einziger knechtet, die Freiheit schenken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("bei dem\nKlange seiner Stimme zusammenschreckend")]), _vm._v("): Wie heißt du?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Ich habe keinen Namen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Wo sind deine Freunde?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Ich habe keine\nFreunde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Laß mich dein Gesicht\nsehn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Da wirst du nur Leiden\nsehen. Sie haben mich gefoltert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("reißt\nihm den Mantel vom Gesicht")]), _vm._v("): Gott im Himmel! Dimitri! Mein\nBruder!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Still, Vera! Sei ruhig.\nDer Vater darf es nicht wissen, es wäre sein Tod. Ich dachte, ich\nkönnte Rußland befreien. Ich hörte eines Abends in einem Café, wie\nLeute von Freiheit sprachen. Ich hatte das Wort vorher niemals\ngehört. Mir schient ein neuer Gott zu sein, von dem sie sprachen.\nIch habe mich ihnen angeschlossen. Dazu hab' ich all das Geld\ngebraucht. Vor fünf Monaten haben sie uns ausgehoben. Sie fanden\nmich, wie ich den Aufruf druckte. Jetzt gehe ich auf Lebenszeit in\ndie Bergwerke. – Ich konnte euch nicht schreiben. Ich wollte euch\nlieber glauben lassen, ich sei tot, denn man wirft mich lebend ins\nGrab.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("um sich\nblickend")]), _vm._v("): Du mußt fliehn, Dimitri. Ich will für dich\ngehn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Unmöglich! Nur eines\nkannst du: uns rächen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Ich will euch rächen!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dimitri")]), _vm._v(": Hör' mich an! In Moskau\nist ein Haus – "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page12",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wachtmeister")]), _vm._v(": Achtung, Gefangene! –\nDer Oberst kommt – Mädel, deine Zeit ist um. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Der Oberst, sein Adjutant und Peter erscheinen.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Ich hoffe, Eure Hoheit\nwerden mit dem Wild zufrieden gewesen sein. Ich habe es selbst\ngeschossen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Es hätte besser geschmeckt,\nwenn du weniger darüber geschwätzt hättest. Wachtmeister,\nfertigmachen! ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Reicht Peter eine\nBörse.")]), _vm._v(") Hier, du Gauner!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Mein Glück ist gemacht!\nLanges Leben Eurer Hoheit! Ich hoffe, Eure Hoheit wird noch oft\ndiesen Weg machen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Beim heiligen Nikolaus,\nhoffentlich nicht. Hier ist es zu kalt für mich. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Zu Vera")]), _vm._v("): Und du, junge Dirne, frage nicht wieder\nDinge, die dich nichts angehen. Dein Gesicht werd' ich nicht\nvergessen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(": Und ich Eures nicht – auch\ndas nicht, was Ihr tut.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Ihr Bauern seid zu\nübermütig geworden, seitdem ihr nicht mehr Sklaven seid. Die Knute\nist der beste Lehrmeister, euch Politik beizubringen. Wachtmeister,\nvorwärts! ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Der Oberst dreht sich um und geht\ndem Hintergrunde der Bühne zu. Die Gefangenen verlassen in\nDoppelreihen das Zimmer. Im Augenblick, wo Dimitri an Vera\nvorbeikommt, läßt er ein Stück Papier zu Boden fallen. Sie verbirgt\nes unter ihrem Fuße und bleibt dann regungslos stehen.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("der\nindessen das Geld gezählt hat, das ihm der Oberst gegeben")]), _vm._v("):\nLanges Leben Eurer Hoheit. Hoffentlich seh ich bald wieder einen\nneuen Trupp. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Plötzlich erblickt er Dimitri,\nder eben durch die Tür geht, und fährt schreiend auf.")]), _vm._v(")\nDimitri, Dimitri, um Gottes willen! Wie kommst du her? Er ist\nunschuldig, ich schwör's Euch! Ich will ihn auslösen. Nehmt Euer\nGeld ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("wirft das Geld zu Boden")]), _vm._v("), nehmt\nalles, was ich habe, gebt mir meinen Sohn. Ihr Schufte, Schufte,\nwohin bringt ihr ihn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Nach Sibirien, alter Mann.\n"), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page13",
      "title": "divisi/a41b"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Nein, nein – nehmt lieber\nmich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oberst")]), _vm._v(": Er ist ein Nihilist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(": Du lügst! Du lügst! Er ist\nunschuldig. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Die Soldaten stoßen ihn mit ihren\nGewehren zurück und werfen die Tür vor ihm ins Schloß. Er schlägt\nmit den Fäusten dagegen.")]), _vm._v(") Dimitri! Dimitri! Ein Nihilist! (\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Er wirft sich zu Boden.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Vera")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("die\nregungslos stehengeblieben ist, zieht das Papier unter ihrem Fuße\nhervor und liest")]), _vm._v("): »Moskau, Tschernavayasiraße 99. Wir\nschwören zu morden, was noch Natur in uns ist. Nicht Liebe zu\ngeben, nicht Liebe zu nehmen. Mitleid weder dir noch mir. Nicht\nBrautstand, nicht Hochzeit, bis das Ende gekommen.« Mein Bruder,\nich werde den Schwur halten. ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Küßt das\nPapier.")]), _vm._v(") Du sollst gerächt werden! ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("Bleibt unbeweglich stehen, das Papier in der erhobenen\nHand.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("liegt\nauf dem Boden")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Michael")]), _vm._v(" ( "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("der\neben eingetreten ist, beugt sich über ihn")]), _vm._v("). "), _c('a', {
    staticClass: "pcalibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "page14",
      "title": "divisi/a41b"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e068df6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter2.vue
// module id = 63
// module chunks = 0